/**
 * Moves an entry of an object keyed by id (insertion order matters) from one
 * position to another and returns a new object.
 */
export const reorderById = (itemsById = {}, from, to) => {
	const items = Object.values(itemsById);
	if (from < 0 || from >= items.length || to < 0 || to >= items.length) {
		return itemsById;
	}
	const [moved] = items.splice(from, 1);
	items.splice(to, 0, moved);
	return Object.fromEntries(items.map(item => [item._id, item]));
};
